import { goToLink } from "@actions/common";
import { getFreespins } from "@actions/profile";
import { showAlert } from "@components/alert/action";
import Loading from "@components/loading/index.jsx";
import NoContent from "@pages/profile-v2/pages/history-v2/components/NoContent";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { BonusWrapper } from "../../elements";
import FreeSpinItem from "./Item";

const FreeSpin = ({ getFreespins, freespinHistory, translate, goToLink, showAlert }) => {
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		setLoading(true);
		getFreespins(() => {
			setLoading(false);
		});
	}, []);

	return loading ? (
		<Loading loading={loading} />
	) : freespinHistory.length === 0 ? (
		<NoContent
			translate={translate}
			title={"NoInfoText"}
			description={"NoInfoBonus"}
			noBackground={true}
		/>
	) : (
		<BonusWrapper>
			{freespinHistory
				?.filter((item) => item.amount !== 0)
				.map((item, index) => (
					<FreeSpinItem
						key={item?.key}
						data={item}
						goToLink={goToLink}
						translate={translate}
						showAlert={showAlert}
						index={index}
					/>
				))}
		</BonusWrapper>
	);
};

const mapStateToProps = (state) => ({
	freespinHistory: state.profile.freespinHistory,
});

const mapDispatchToProps = {
	getFreespins,
	goToLink,
	showAlert,
};

export default connect(mapStateToProps, mapDispatchToProps)(FreeSpin);
